import { InterviewArticleType } from 'components/v2/molecules/article-interview';
import { ArticleCategoryEnum, ArticleTypeEnum } from 'service/article';

const data: InterviewArticleType = {
  id: 'interview-kuu-chan',
  title: '「投資は簡単ではない、だから面白い」くーちゃんインタビュー',
  breadcrumbItems: [
    { label: 'ホーム', href: '/about' },
    { label: 'クリエイター', href: '/about/creator' },
    {
      label: '「投資は簡単ではない、だから面白い」くーちゃんインタビュー',
    },
  ],
  excerpt: `投資に出会い、しのぎを削る中で得た投資の掟。`,
  category: ArticleCategoryEnum.Creator,
  type: ArticleTypeEnum.ForCreator,
  date: '2025年10月8日',
  thumbnail: 'https://assets.postprime.com/internals/kuuchan-profile.jpg',
  href: '/about/creator/interview-kuu-chan',
  metadata: {
    title:
      '「投資は簡単ではない、だから面白い」くーちゃんインタビュー | PostPrime',
    description:
      '「一瞬での無一文」の絶望を乗り越え、億り人へと這い上がった投資人生。 間違いなく人生を変えた19年の投資の中で何を感じ、学びとってきたのかを 余すことなくPostPrimeで発信。 今回はPostPrimeのトップクリエイターとして活躍する「くーちゃん」に 投資哲学とPostPrimeへの想いを聞いた。',
    image: 'https://assets.postprime.com/internals/kuuchan-profile.jpg',
    url: 'https://postprime.com/about/creator/interview-kuu-chan',
    keywords:
      'PostPrime, くーちゃん, クリエイターインタビュー, 投資家, 専業投資家, 投資哲学, 市場分析, コミュニティ',
  },
  readTime: '15分',
  author: {
    name: 'Trung(ちゅん)',
    avatar: 'https://assets.postprime.com/internals/trung.jpg',
    jobTitle: 'CEO',
  },
  content: '',

  // Interview-specific data
  interviewLabel: 'Creator Interview Vol.1',
  heroSubtitle: '投資に出会い、しのぎを削る中で得た投資の掟。',
  leadText: `「一瞬での無一文」の絶望を乗り越え、億り人へと這い上がった投資人生。
間違いなく人生を変えた19年の投資の中で何を感じ、学びとってきたのかを
余すことなくPostPrimeで発信。
今回はPostPrimeのトップクリエイターとして活躍する「くーちゃん」に
投資哲学とPostPrimeへの想いを聞いた。`,

  pullQuote: `PostPrimeは単なる投資プラットフォームではない。<br>
投資家として成長できる場所、<br>
それが私にとってのPostPrimeです。`,

  pullQuoteIndex: 3,
  creatorProfile: {
    name: 'くーちゃん',
    title: 'PostPrime トップクリエイター',
    avatar: 'https://assets.postprime.com/internals/kuuchan-profile.jpg',
    profileUrl: 'https://postprime.com/mini_kuchan',
  },

  questions: [
    {
      id: 'q1',
      questionNumber: '1',
      questionText: '学びの道のり (学びの道)',
      answerText: `
        <ul>
          <li>
            <p><h2><strong>企業に値段がついている驚きが投資のきっかけ</strong></h2></p>
            <p>小学生の時にテレビで偶然株式ニュースの番組を見て、企業に値段(株価)がついていることを知り、会社って買えるのか！？ということから株に興味を持ちました。</p>
            <p>新聞欄の株価一覧情報などを眺めていても苦痛では無く、楽しかったのですんなりと「なぜ」株価が変動するのかを考えていくキッカケになりました。当時、親から株はギャンブルだと言われてたので親に隠れて新聞見てました(笑)</p>
          </li>
          <li>
            <p><h2><strong>初めての投資経験で5歳の時から貯めたお小遣いやお年玉を失う</strong></h2></p>
            <p>大学生の時、20歳の誕生日にすぐ証券会社の口座開設を行い、投資をスタートしました。</p>
            <p>その結果、半年間で5歳の時から貯めたお小遣いやお年玉をすべて失いました。その後、数千万の損失を出したり、億り人になったことよりも15年間我慢して貯めたお金をすべて無くしてしまった当時の苦い記憶の方が心に残っています。</p>
          </li>
          <li>
            <p><h2><strong>毎朝と空いている時間は継続的な投資の学習</strong></h2></p>
            <p>毎日主要な経済のデータ発表や注目している企業のIRページ、そして決算時期には決算書を確認します。</p>
            <p>注目している商品において必要な情報も常にウォッチしています。例)コモディティであれば主要国の生産・天候情報、暗号資産であれば各財団の動きなど。</p>
            <p>毎朝はもちろんですが朝だけでは無く、空いた時間があれば基本的に投資関連の情報収集と企業分析をやっています。情報を点で扱うのでは無く、線で見ていくことでやがて面として捉えれるように日々学習しています。</p>
          </li>
        </ul>
      `,
    },
    {
      id: 'q2',
      questionNumber: '2',
      questionText: 'くーちゃんさんの投資においてのルーティーン',
      answerText: `
        <p>大切なデータ(例えばCPIや企業決算)はニュースサイトで見るだけでなく発表元の資料を可能な限り確認します。</p>
        <p>ニュースサイトは閲覧を集める為に結果を重視しますが、投資に大切なのは結果に繋がる個々の詳細な状況です。</p>
        <ul>
          <li>
            <p>CPIではどのセクターがどれくらい、そしてなぜ上下しているのか。</p>
          </li>
          <li>
            <p>企業決算ではなぜ数字が好不調なのか、その要因は一時的なのか継続するのか。</p>
          </li>
        </ul>
        <p>失敗する時は往々にしてうわべだけで判断していて本質を見逃している時です。</p>
        <p>全力で考え抜いてポジションを取ったあとは『その理由が今も変わっていないか』を日々変動する状況で自問自答するだけです。</p>
        <p>変わっていないのであればポジションを変えず、変わっているのであれば利確か損切りかなどは判断に影響せずポジションを解消します。</p>
      `,
    },
    {
      id: 'q3',
      questionNumber: '3',
      questionText: '発信において大切にしていることはありますか',
      answerText: `
        <p>多くの方は本業を行いながら投資を実践されている兼業投資家になるので、短期的なポジションというよりも、経済などのマクロ視点と企業の決算などのミクロ視点をしっかりと捉えた上で、価値が上昇する可能性が高い対象を見極めて時間を使った投資を重要としています。</p>
        <p>何よりも大切なのが投資は「手段」であって「目的」では無いことです。</p>
        <p>資産を増やすことで選択肢の広がりや、安心を得ることが目的なので投資に振り回されて大切なことを見失わないことが肝要です。</p>
        <p>日々のお仕事、友人関係、家族との時間を大切にした上で、拙速なポジションを繰り返すのではなく、どのようにポートフォリオを管理してポジションを取っていくべきかを分かりやすく発信することを一番心がけています。</p>
      `,
    },
    {
      id: 'q4',
      questionNumber: '4',
      questionText:
        'くーちゃんさんの投資手法に関して聞かせていただけませんでしょうか。',
      answerText: `
        <ul>
          <li>
            <p><h2><strong>くーちゃんさんのカバーしている市場セクターはなんでしょうか</strong></h2></p>
            <p>日本株、米国株、暗号資産、債券、コモディティについて情報収集と発信しています。</p>
            <p>仕事をしている時と寝ている時以外はほぼ投資について調べたり考えたりしています。</p>
            <p>一度だけ「全部について話しているから信用して良いか判断できません」と言われた時は苦笑いしか出来なかったことがあります(笑)</p>
          </li>
          <li>
            <p><h2><strong>くーちゃんさんの分析手法の気を付けている点は何ですか？</strong></h2></p>
            <p>チャートも見ますが根幹はファンダメンタルズです。</p>
            <p>投資は自分が見ている時間軸に対して今の市場がどれだけひずんでいるかを捉えることが重要だと思っており、ポジションに対する根拠と論拠をはっきり出しやすいのが個人的には企業や経済を分析することだと思っています。</p>
            <p>その上でチャートの強弱もポジションを取る最終的な時に補助程度で考慮します。</p>
          </li>
        </ul>
      `,
    },
    {
      id: 'q5',
      questionNumber: '5',
      questionText:
        'PostPrimeを含めた投資のコミュニティなどの構築で意識していることはありますか？',
      answerText: `
        <ul>
          <li>
            <p><h2><strong>どのようにフォロワーの方を中心にフォローしていますか？</strong></h2></p>
            <p>日々のライブでの質問、依頼された企業の決算解説などを通じて様々な疑問に対して一緒に考え、回答しています。</p>
            <p>結論だけではなく、「なぜ」そう考えるに至ったかについての説明を大切にしています。</p>
            <p>個人主催のリアルイベントとして過去に食事会を5回ほど開催させて頂きましたが、今後も投資家仲間としての繋がりを大切にするために開催していきたいと思います。</p>
          </li>
          <li>
            <p><h2><strong>PostPrimeで発信しているコンテンツの種類や投資カテゴリーなどを教えていただけますか？</strong></h2></p>
            <p>ポストプライムでは本アカウントとサブチャンネルの2つの他、YoutubeやDiscordといったコミュニケーションアプリを通じて経済や株式はじめコモディティ・暗号資産など多岐にわたる投資に対して皆様と戦略を共有しています。</p>
          </li>
        </ul>
      `,
    },
    {
      id: 'q6',
      questionNumber: '6',
      questionText:
        'PostPrimeの活動や投資において思い入れが高いエピソードなどありますでしょうか。',
      answerText: `
        <p>いつもライブで「耳にたこができる」ほど言っている「買った理由は何か」そして「その理由は今も継続しているか」を実践して変なポジションが減ったとお声を頂きました。</p>
        <p>また、決算分析についてもライブで実際に企業の決算資料からじっくり解説していく中でどのように決算書を見ていくのか参考になるといったコメントを頂きこちらも感謝しています。</p>
        <p>あとは私が純粋に注目しているセクターや分野などをライブで話した後に、利益を出せたという報告を頂くこともあり純粋にうれしいです。</p>
      `,
    },
  ],

  keyInsights: {
    title: 'くーちゃんが実践する3つの投資原則',
    items: [
      {
        icon: '🔍',
        title: '誰よりも詳しくなる',
        description:
          '投資対象について「対象企業の社長よりも詳しいか？」を常に自問して本気で向き合う。',
      },
      {
        icon: '✨',
        title: '単純ではなくシンプルに',
        description:
          '選択肢が無い中では"単純"、数多の選択肢を排除したものを"シンプル"と捉え、シンプルを目指す。',
      },
      {
        icon: '💪',
        title: 'ぬるい投資をしない',
        description:
          'ポジションの根拠と論拠を明確にし、自分の考えうる最高のポートフォリオを築く。',
      },
    ],
  },

  ctaSection: {
    title: 'くーちゃんをフォローして\n投資の最前線を体験しよう',
    description: '毎日の市場分析と実践的な投資戦略を無料で学べます',
    buttonText: '今すぐフォローする',
    buttonUrl: 'https://postprime.com/mini_kuchan',
  },
};

export default data;
